import React from 'react';
import { motion } from 'framer-motion';
import { FaAward, FaUsers, FaCamera, FaHeart } from 'react-icons/fa';
import './About.css';
import aboutImage from './IMG_9388.JPEG';

const About = () => {
  const stats = [
    { icon: <FaCamera />, number: '50+', label: 'Projects Completed' },
    { icon: <FaUsers />, number: '10+', label: 'Happy Clients' },
    { icon: <FaHeart />, number: '5+', label: 'Years Experience' }
  ];

  return (
    <section id="about" className="about">
      <div className="about-container">
        <motion.div
          className="about-content"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">About Us</h2>
          <div className="title-underline"></div>
          
          <p className="about-text">
            My name is Ishimwe Aime Blaise from Rwanda, a passionate photographer and 
            video editor dedicated to capturing life's most beautiful moments. Through 
            my lens, I tell stories that resonate, creating visual narratives that 
            blend artistic vision with technical excellence.
          </p>
          
          <p className="about-text">
            My work spans portrait photography, commercial projects, and nature photography, 
            with a keen eye for detail and composition. Each project is an opportunity to 
            showcase the unique beauty of my subjects, whether it's the emotion in a 
            portrait, the energy of a commercial shoot, or the tranquility of nature.
          </p>

          <p className="about-text">
            Based in Kigali, Rwanda, I combine creative storytelling with professional 
            post-production skills to deliver stunning imagery and captivating videos. 
            My goal is to transform every moment into a timeless piece of art that 
            exceeds expectations.
          </p>
        </motion.div>

        <motion.div
          className="about-image"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="image-wrapper">
            <img src={aboutImage} alt="About Us" className="about-img" />
          </div>
        </motion.div>
      </div>

      <div className="stats-container">
        {stats.map((stat, index) => (
          <motion.div
            key={index}
            className="stat-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="stat-icon">{stat.icon}</div>
            <h3 className="stat-number">{stat.number}</h3>
            <p className="stat-label">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default About;
